<div class="quicksight-container">
    <ng-container *ngIf="embedUrl; else loading">
      <iframe [src]="embedUrl" class="quicksight-iframe"></iframe>
    </ng-container>
    <ng-template #loading>
      <p>Cargando tablero de BI...</p>
    </ng-template>
  </div>